import styled from 'styled-components'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${p => p.cols}, 1fr);
  grid-auto-rows: 1fr;
  gap: 2px;
  background: #1b1b1b;
  border: 1px solid #d9d9d9;
  height: ${p => p.height}px;
  overflow: hidden;
`

export const Cell = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: #000;
  border: 2px solid ${p => (p.selected ? '#d0021b' : 'transparent')};
  min-width: 0;
  min-height: 0;
  cursor: pointer;
`

/** กล้องหลายตัวในกรอบเดียว — 2 คอลัมน์ ตัวสุดท้ายที่เหลือเดี่ยวกินเต็มแถว */
export const CameraGrid = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(${p => Math.min(p.count, 2)}, 1fr);
  grid-auto-rows: 1fr;
  gap: 2px;
  background: #1b1b1b;

  & > :last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }
`

export const CellBody = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  background: #000;
  overflow: hidden;

  video,
  iframe {
    width: 100%;
    height: 100%;
    display: block;
    border: 0;
    background: #000;
    object-fit: contain;
  }
`
